import request from '@/utils/request'

export function updateAgreements(data) {
  return request({
    url: '/agreement',
    method: 'post',
    data: data
  })
}

export function fetchAgreement(id) {
  return request({
    url: `/agreement/${id}`,
    method: 'get'
  })
}
